import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { LanguageContextService } from '@core/services/context/language-context.service';
import { Language, LanguageId } from '@models/language';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-select-global-language',
  templateUrl: './select-global-language.component.html'
})
export class SelectGlobalLanguageComponent implements OnInit, OnDestroy {

  @Output() newLanguage = new EventEmitter<LanguageId>();

  supportedLanguages: Language[];
  selectedLanguageId: string;

  selectedLanguageIdSubscription: Subscription;

  constructor(
    private languageCtx: LanguageContextService
  ) { }

  ngOnInit() {
    this.loadLanguages();
  }

  ngOnDestroy() {
    if (this.selectedLanguageIdSubscription) {
      this.selectedLanguageIdSubscription.unsubscribe();
    }
  }

  onChangeLanguage(language: Language) {
    this.newLanguage.emit(language.id);
    this.languageCtx.setLanguageById(language.id);
  }

  private loadLanguages() {
    this.supportedLanguages = this.languageCtx.getSupportedLanguages();
    this.selectedLanguageIdSubscription = this.languageCtx.getSelectedLanguageIdAsObservable().subscribe((id) => {
      this.selectedLanguageId = id;
    });
  }

}
